import ProgressBar from '@atoms/ProgressBar/ProgressBar';
import Spinner from '@molecules/Spinner/Spinner';
import { useTranslations } from 'next-intl';
import { StyledWrapper, StyledInfo, StyledContent, StyledButton } from './LoadMore.styles';

interface Props {
  total: number;
  limit: number;
  pageSize?: number;
  onClick: () => void;
  showProgress: boolean;
  loading?: boolean;
}

const LoadMore = ({ total, limit, pageSize, onClick, loading = false, showProgress }: Props) => {
  const t = useTranslations('loadMore');

  if (limit >= total) {
    return null;
  }

  const hasMorePages = pageSize !== undefined && limit + pageSize < total;
  const buttonLabel = hasMorePages ? 'showMore' : 'showAll';

  return (
    <StyledWrapper data-testid="loadmore-wrapper">
      <StyledContent>
        {showProgress && (
          <>
            <StyledInfo type="subhead" size="small">
              {t('showing', { limit, total })}
            </StyledInfo>
            <ProgressBar progress={limit} total={total} />
          </>
        )}
        <StyledButton variant="primary" onClick={onClick} data-testid="load-more-btn" disabled={loading}>
          {loading ? <Spinner color="white" /> : t(buttonLabel)}
        </StyledButton>
      </StyledContent>
    </StyledWrapper>
  );
};

export default LoadMore;
